// extracted by mini-css-extract-plugin
module.exports = {"leftSideWrapper":"_1SLNc","center":"_2yth3","backBtn":"_2PVWK"};